import { extendComponent } from "@eusoft/webapp-core";
import { ItemEditContent } from "@eusoft/webapp-framework";
import { forModel } from "@eusoft/webapp-jsx";
import { ObjectEditor, emptyObject, enumItemsSource, formatText, required, staticItemsSource } from "@eusoft/webapp-ui";
import { AddressEditor } from "../../components/AddressEditor";
import { SaleCircuitType } from "../../entities/Commands";
import { Authorize } from "../../services/Authorize";
import { executeAsync } from "../../services/DataService";
import type { Guid, ICreateSaleCircuit } from "../../entities/Commands";




export interface IEditSaleCircuit extends ICreateSaleCircuit {
    id: Guid;
    useCurrency?: boolean;
    useAddress?: boolean;
}

const SaleCircuitEditor = extendComponent(ObjectEditor<IEditSaleCircuit>, {}, {

    commitMode: "manual",
    style: "vertical",
    inputField: { style: "filled" },

    builder: bld => <>

        {bld.text(a => a.name, {
            validators: [required]
        })}

        {bld.singleSelector(a => a.type, {
            validators: [required],
            editor: {
                itemsSource: enumItemsSource(SaleCircuitType)
            }
        })}

        {bld.boolean(a => a.useAddress, {
            onChanged: (m, v) => {
                console.debug("useAddress", v);
                m.address = emptyObject("sale-reset");
            },
            label: "specify-address"
        })}


        {bld.boolean(a => a.useCurrency, {
            onChanged: (m, v) => {
                if (!v) {
                    m.conversionRate = null;
                    m.currency = null;
                }
            },
            label: "use-custom-currency"
        })}


        {bld.editor(a => a.address, AddressEditor, {
            label: "main-address",
            visible: a => a.useAddress === true,
            style: ["vertical-label", "no-box", "no-error"],
            editor: {
                inputField: { style: "filled" },
            }
        })}


        {bld.text(a => a.currency, {
            validators: [required],
            visible: m => m.useCurrency === true,
            label: "currency-name",
            editor: {
            }
        })}

        {bld.singleSelector(a => a.conversionCurrency, {
            validators: [required],
            visible: m => m.useCurrency === true,
            editor: {
                itemsSource: staticItemsSource(["Euro", "EUR"])
            }
        })}

        {bld.number(a => a.conversionRate, {
            validators: [required],
            visible: m => m.useCurrency === true,
            editor: {
            }
        })}

        {bld.content(forModel(a => <>
            {a.currency && a.conversionRate &&
                <span>{formatText("msg-conversion", a.currency, a.conversionCurrency, a.conversionRate?.toString())}</span>}
        </>))}

    </>
});


export const CreateSaleCircuitPage = ItemEditContent.bulder<IEditSaleCircuit>()

    .info({
        name: "sale-circuit-create",
        route: "/sale-circuit/create",
    })

    .feature(Authorize(bld =>
        bld.businessAccount()
            .resource("SaleCircuit", "create")))

    .options({

        title: "create-sale-circuit",
        style: ["panel"],

        createEditor: () => new SaleCircuitEditor(null),

        onLoadArgsAsync: async args => {

            args.value = {
                name: "",
                useAddress: true
            } as IEditSaleCircuit;

            return true;
        },

        onSaveAsync: async value => {

            value.type = parseInt(value.type as any);

            const id = await executeAsync("CreateSaleCircuit", value);

            value.id = id;

            return true;
        }
    }).asContent<any>({
        hideContext: true
    }); 
